var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { createContext, useContext } from "react";
const FeatureEditContext = createContext({});
const FeatureEditContextProvider = FeatureEditContext.Provider;
const useFeatureEditContext = (selector) => selector(useContext(FeatureEditContext));
const FeatureEditProvider = (props) => {
  const { id } = props;
  const defaultState = {
    isEditMode: !id
  };
  const [state, setState] = React.useState(defaultState);
  const setEditMode = (editMode) => setState(__spreadProps(__spreadValues({}, state), { isEditMode: editMode }));
  return /* @__PURE__ */ jsx(
    FeatureEditContextProvider,
    {
      value: __spreadProps(__spreadValues({}, state), {
        setEditMode
      }),
      children: props.children
    }
  );
};
export {
  FeatureEditContext,
  FeatureEditContextProvider,
  FeatureEditProvider,
  FeatureEditProvider as default,
  useFeatureEditContext
};
//# sourceMappingURL=FeatureEditProvider.js.map
